<div class="header-dependente">
  <div class="form-card">
    <form class="form">
      <app-input [inputModel]="dependent.cardNumberInputModel" (isInputValid)="setFormStatus($event, 'meepCardNumber')" [(value)]="dependent.cardNumber"></app-input>
    </form>
    <button *ngIf="routeParams['meepCardNumber']" (click)="confirmDuplicate()" class="confirma">
      Salvar
    </button>
  </div>
</div>


// WEBPACK FOOTER //
// /usr/src/app/src/app/components/confirm-duplicate/confirm-duplicate.component.html